import React, { FC, useState, useEffect } from 'react'
import { IonTextarea } from '@ionic/react'
import './index.scss'

// props
interface IProps {
  dataCypid?: string;
  value: string;
  maxLength?: number;
  onChange: (text: string) => void;
  placeholder?: string;
  showLength?: number;
  autohHeight?: boolean;
}

const UseTextArea: FC<IProps> = ({ value, maxLength = 64, onChange, placeholder, showLength, autohHeight = false, dataCypid }) => {
  return (
    <div className='ion-textarea-wrap'>
      <IonTextarea
        data-cypid={dataCypid}
        value={value}
        autoGrow={autohHeight}
        onIonChange={(e: any) => {
          e.detail.value && e.detail.value.substr(0, maxLength)
          onChange(e.detail.value)
        }}
        className='ion-text-area'
        maxlength={maxLength}
        placeholder={placeholder}
        mode='ios'
      />
      {
        ((showLength && value.length > showLength) || !showLength) ? <div className='count-wrap'>{value.length}/{maxLength}</div> : null
      }
    </div>
  )
}

export default UseTextArea
